import { Component, Input } from '@angular/core';

import * as _ from 'lodash';
import { IOverlayTypologyModel } from 'src/app/interfaces/overlay-typology-model.interface';
import { CalibrationSetAttributesComponent } from './calibration-set-attributes/calibration-set-attributes.component';

@Component({
    standalone: false,
    selector: 'overlay-typology-attributes',
    templateUrl: './attributes.component.html',
    styleUrls: ['./attributes.component.scss']

})
export class OverlayTypologyAttributesComponent extends CalibrationSetAttributesComponent {
    @Input()
    overlayTypology: IOverlayTypologyModel;

    get attributesStatistic() {
        return this.overlayTypology;
    }
}
